import { environment } from '../../environments/environment';

export class ApiConnection {
    static BASE_URL = environment.apiServerUrl;
    static API_VERSION = environment.apiVersion;
    static FILE_SERVER_URL = environment.fileServerUrl;
    static FILE_VERSION = environment.fileVersion;
    static DEFAULT_LANGUAGE = environment.defaultLanguage;
}
